let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eCcKD")).then(() => parcelRequire('1sSnn'));